import React, { useState, Suspense, lazy } from 'react';
import heroImage from '../../img/hero.webp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUtensils } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-hot-toast';

const OrderModal = lazy(() => import('../OrderModal'));

const menuItems = [
  { id: 1, name: 'Hummus', price: 9 },
  { id: 2, name: 'Baba Ghanouj', price: 9 },
  { id: 3, name: 'Mutabbal Shamandar', price: 9 },
  { id: 4, name: 'Muhammara', price: 9 },
  { id: 5, name: 'Mutabbal Eggplants', price: 9 },
  { id: 6, name: 'Tabbouleh Salad', price: 9 },
  { id: 7, name: 'Super Combo', price: 39 },
];

export default function NavBar() {
  const [shouldLoadModal, setShouldLoadModal] = useState(false);

  const handlePaymentSuccess = (checkoutToken) => {
    toast.success(
      '🎉 Order placed successfully! Thank you for your purchase. Your order is being prepared',
      {
        position: 'top-right',
        autoClose: 15000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        style: {
          backgroundColor: 'green',
          color: 'white',
        },
      }
    );
  };

  return (
    <>
      <div className="container-xxl position-relative p-0">
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark px-4 px-lg-5 py-3 py-lg-0">
          <a href="#home" className="navbar-brand p-0">
            <h1 className="text-primary m-0 font_trial">
              <FontAwesomeIcon icon={faUtensils} className="text-primary" />{' '}
              Zestify
            </h1>
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
            aria-controls="navbarCollapse"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="fa fa-bars"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarCollapse">
            <div className="navbar-nav ms-auto py-0 pe-4">
              <a href="#about" className="nav-item nav-link" id="about_nav">
                About
              </a>
              <a href="#menu" className="nav-item nav-link" id="menu_nav">
                Menu
              </a>
              <a
                href="#diet_section"
                className="nav-item nav-link"
                id="diet_nav"
              >
                Our Diet
              </a>
              <a href="#membership" className="nav-item nav-link" id="team_nav">
                Members
              </a>
              <a href="#special" className="nav-item nav-link" id="special_nav">
                Treat Yo' Guests
              </a>
              <a href="#contact" className="nav-item nav-link" id="contact_nav">
                Contact
              </a>
            </div>
            <button
              type="button"
              className="btn btn-primary py-2 px-4 border_design"
              data-bs-toggle="modal"
              data-bs-target="#orderModal"
              onClick={() => setShouldLoadModal(true)}
            >
              Order Online
            </button>
          </div>
        </nav>
      </div>

      {/* Hero Section */}
      <div
        className="container-xxl py-5 bg-dark hero-header mb-5 section_cc"
        id="home"
      >
        <div className="container my-5 py-5">
          <div className="row align-items-center g-5">
            <div className="col-lg-6 text-center text-lg-start">
              <h1 className="display-3 text-white animated slideInLeft">
                Mediterranean Food That Lifts Your Mood
              </h1>
              <p className="text-white animated slideInLeft mb-4 pb-2 font-awesome">
                The Mediterranean diet is rich in antioxidants, fiber, and
                healthy fats. It has many benefits for your health and
                well-being, including your heart, blood pressure, and
                cholesterol. It can also help you lose weight or maintain a
                healthy weight.
              </p>
            </div>
            <div className="col-lg-6 text-center text-lg-end overflow-hidden scale_bigger">
            <img
  className="img-fluid border_radius"
  src={heroImage}
  alt="Mediterranean food"
  width="600"
  height="600"
  decoding="async"
  loading="eager"
  fetchPriority="high"
/>
            </div>
          </div>
        </div>
      </div>
      {shouldLoadModal && (
        <Suspense fallback={null}>
          <OrderModal
            items={menuItems}
            deliveryCharge={3}
            salesFeeRate={6.625 / 100}
            onPaymentSuccess={handlePaymentSuccess}
          />
        </Suspense>
      )}
    </>
  );
}
